import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformAnalytics = ({ analyticsData }) => {
  const { wasteReduction, participationRate, customerSatisfaction, totalBagsSold, co2Saved, waterSaved } = analyticsData;

  const getScoreColor = (score) => {
    if (score >= 80) return 'var(--color-success)';
    if (score >= 60) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  const getScoreIcon = (score) => {
    if (score >= 80) return 'CheckCircle';
    if (score >= 60) return 'AlertCircle';
    return 'XCircle';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Análisis de Plataforma
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            Datos automáticos para verificación
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="BarChart3" size={20} color="var(--color-primary)" />
          <span className="text-sm font-medium text-foreground">Actualizado hoy</span>
        </div>
      </div>

      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Recycle" size={20} color="var(--color-success)" />
            <Icon 
              name={getScoreIcon(wasteReduction)} 
              size={16} 
              color={getScoreColor(wasteReduction)} 
            />
          </div>
          <h3 className="font-medium text-foreground mb-1">Reducción de Residuos</h3>
          <div className="flex items-baseline space-x-2">
            <span className="text-2xl font-bold text-foreground">{wasteReduction}%</span>
            <span className="text-sm text-muted-foreground">vs. promedio</span>
          </div>
        </div>

        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
            <Icon 
              name={getScoreIcon(participationRate)} 
              size={16} 
              color={getScoreColor(participationRate)} 
            />
          </div>
          <h3 className="font-medium text-foreground mb-1">Participación Consistente</h3>
          <div className="flex items-baseline space-x-2">
            <span className="text-2xl font-bold text-foreground">{participationRate}%</span>
            <span className="text-sm text-muted-foreground">días activos</span>
          </div>
        </div>

        <div className="bg-muted/30 p-4 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <Icon name="Heart" size={20} color="var(--color-accent)" />
            <Icon 
              name={getScoreIcon(customerSatisfaction)} 
              size={16} 
              color={getScoreColor(customerSatisfaction)} 
            />
          </div>
          <h3 className="font-medium text-foreground mb-1">Satisfacción Cliente</h3>
          <div className="flex items-baseline space-x-2">
            <span className="text-2xl font-bold text-foreground">{customerSatisfaction}%</span>
            <span className="text-sm text-muted-foreground">valoraciones</span>
          </div>
        </div>
      </div>

      {/* Impact Metrics */}
      <div className="border-t border-border pt-4">
        <h3 className="font-medium text-foreground mb-3">Impacto Ambiental Acumulado</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="ShoppingBag" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-lg font-bold text-foreground">{totalBagsSold}</p>
              <p className="text-sm text-muted-foreground">bolsas vendidas</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
              <Icon name="Leaf" size={20} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-lg font-bold text-foreground">{co2Saved} kg</p>
              <p className="text-sm text-muted-foreground">CO₂ evitado</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="Droplets" size={20} color="var(--color-accent)" />
            </div>
            <div>
              <p className="text-lg font-bold text-foreground">{waterSaved} L</p>
              <p className="text-sm text-muted-foreground">agua ahorrada</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAnalytics;